'use strict';

angular.module('licensure.helpers')
    .factory('HttpPendingRequests', ['$q', '$rootScope', function ($q, $rootScope) {
        var cancelPromises = [];

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromise.promise.state = $rootScope.$state.current;
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll(state) {
            angular.forEach(cancelPromises, function (cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };
    }])
;